var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('gc-public-header'),_vm._v(" "),_c('keep-alive',{attrs:{"max":1}},[(_vm.$route.meta.keep)?_c('router-view',{staticClass:"common-view",style:({'height': _vm.height + 'px'})}):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keep)?_c('router-view',{staticClass:"common-view",style:({'height': _vm.height + 'px'})}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76fe5da2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = fvpn
// module chunks = 82